// extracted by mini-css-extract-plugin
export default {"resizablePanel":"resizable-panel_resizablePanel__Ee5G3","splitter":"resizable-panel_splitter__kwsAn"};